export default {
  namespaced: true,
  state() {
    return {
      formData: {},
      validators: {},
      errors: []
    }
  },
  mutations: {
    changeFormData(state, payload) {
      Object.assign(state.formData, payload)
    },
    changeValidators(state, payload) {
      Object.assign(state.validators, payload)
    },
    addError(state, payload) {
      state.errors.push(payload)
    },
    removeError(state, payload) {
      state.errors = state.errors.filter(error => !Object.prototype.hasOwnProperty.call(error, payload))
    },
    clearErrors(state) {
      state.errors = []
    }
  },
  actions: {
    changeFormData({ commit }, payload) {
      commit('changeFormData', payload)
    },
    changeValidators({ commit }, payload) {
      commit('changeValidators', payload)
    },
    addError({ commit }, payload) {
      commit('addError', payload)
    },
    removeError({ commit }, payload) {
      commit('removeError', payload)
    },
    clearErrors({ commit }) {
      commit('clearErrors')
    }
  },
  getters: {
    formData: state => state.formData,
    validators: state => state.validators,
    errors: state => state.errors
  }
}
